import { GET_MASTER_DATA, GET_SHIPS_DATA, GET_VIP_ICONS_DATA } from './../constants/actionTypes'

export const getMasterDataAction = ({ data, settings ,isShore }) => dispatch => {
  dispatch({
    type: GET_MASTER_DATA,
    data,
    settings,
    isShore
  })
}

export const getShipsDataAction = data => dispatch => {
  dispatch({
    type: GET_SHIPS_DATA,
    data
  })
}

export const getVipIconAction = data => dispatch => {
  dispatch({
    type: GET_VIP_ICONS_DATA,
    data
  })
}
